import MonthCalendarCard from "./components/MonthCalendarCard";
import "./darkSurface.css";

// Sayfa tek bir işe odaklanıyor: ay takvimi ve seçili günün girişleri.
// Hesap ayarları (bilgi düzenleme, şifre, hesap silme) sol menüdeki
// kullanıcı menüsüne taşındı — bkz. app/shell/SideNav.jsx.
export default function ProfilePage() {
  return (
    <div className="tk-dark w-full lg:h-full">
      <MonthCalendarCard />
    </div>
  );
}
